import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[scipS2sKeyValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: S2sKeyValidatorDirective, multi: true }]
})
export class S2sKeyValidatorDirective implements Validator {
  static validS2SKey(control: AbstractControl): ValidationErrors | null {
    if (control.value && control.value.length > 0) {
      const currentValue = control.value.toString();
      if (currentValue.includes('_') || currentValue.includes('-') || currentValue.includes(' ')) {
        return { s2skeyInvalid: { value: control.value } };
      }
    }
    return null;
  }
  validate(control: AbstractControl): { [key: string]: any } | null {
    return S2sKeyValidatorDirective.validS2SKey(control);
  }
}
